export const mxDialCode  = "52";
export const coDialCode  = "57";

export type CountryCode = {
    code: string;
    dialCode: string;
    label: string;
}

export const countryCodes: CountryCode[] = [
    {code: "mx", dialCode: mxDialCode, label: "+52"},
    {code: "co", dialCode: coDialCode, label: "+57"},
];

export const getCountry = (countryCode: string): CountryCode => countryCodes.filter((item) => item.code === countryCode)[0];

export const formatPhone = (phone: string, countryCode: string = "mx"): string => {
    let { dialCode } = getCountry(countryCode);

    // eslint-disable-next-line no-const-assign
    if (dialCode === mxDialCode) dialCode = `${mxDialCode}1`;

    if (phone.length === 10) return `${dialCode}${phone}`;
    return phone;
};

export const unformatPhone = (phone: string): string => {
    let { dialCode } = getCountry("mx");

    if (phone.startsWith("57")) {
        dialCode = getCountry("co").dialCode;
    }

    // eslint-disable-next-line no-const-assign
    if (dialCode === mxDialCode) dialCode = `${mxDialCode}1`;

    return phone.replace(dialCode.toString(), "");
};
